
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeShopDialog extends Serenity.EntityDialog<PsDiscCouponTypeShopRow, any> {
        protected getFormKey() { return PsDiscCouponTypeShopForm.formKey; }
        protected getIdProperty() { return PsDiscCouponTypeShopRow.idProperty; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeShopRow.localTextPrefix; }
        protected getNameProperty() { return PsDiscCouponTypeShopRow.nameProperty; }
        protected getService() { return PsDiscCouponTypeShopService.baseUrl; }
        protected getDeletePermission() { return PsDiscCouponTypeShopRow.deletePermission; }
        protected getInsertPermission() { return PsDiscCouponTypeShopRow.insertPermission; }
        protected getUpdatePermission() { return PsDiscCouponTypeShopRow.updatePermission; }

        protected form = new PsDiscCouponTypeShopForm(this.idPrefix);

    }
}